"use client";

import { useState, useSyncExternalStore } from "react";
import { Icon } from "@/components/ui/Icon";
import { whatsappLink } from "@/config/infos";
import { usePathname } from "next/navigation";
import { localeFromPath } from "@/config/i18n";

const TOOLTIP = {
  fr: "Contactez-nous sur WhatsApp",
  en: "Contact us on WhatsApp",
  ar: "تواصل معنا عبر واتساب",
} as const;

export const WhatsAppCTA = () => {
  const isMounted = useSyncExternalStore(
    () => () => {},
    () => true,
    () => false,
  );
  const [isHovered, setIsHovered] = useState(false);
  const pathname = usePathname();
  const tooltip = TOOLTIP[localeFromPath(pathname ?? "/")];

  if (!isMounted) return null;

  const handleClick = () => {
    window.open(whatsappLink, "_blank", "noopener noreferrer");
  };

  return (
    <div className="fixed bottom-20 end-6 z-[60] hidden items-end gap-4 md:bottom-10 md:end-10 md:flex">
      {isHovered && (
        <div className="animate-fade-in absolute end-[110px] top-1/2 -translate-y-1/2 rounded-xl border border-white/15 bg-black/80 px-4 py-2.5 text-white shadow-[0_10px_30px_rgba(0,0,0,0.45)] backdrop-blur-sm">
          <p className="whitespace-nowrap text-sm font-medium text-white/90">
            {tooltip}
          </p>
          <span className="pointer-events-none absolute end-[-7px] top-1/2 h-3 w-3 -translate-y-1/2 rotate-45 border-b border-e border-white/15 bg-black/80" />
        </div>
      )}
      <div className="relative">
        <button
          onClick={handleClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className={`relative flex h-16 w-16 items-center justify-center rounded-full shadow-lg transition-all duration-300 hover:scale-105 hover:bg-[#01E676] md:h-20 md:w-20 ${
            pathname?.startsWith("/location") ? "bg-gold-200" : "bg-primary"
          }`}
          aria-label={tooltip}
        >
          <span className="absolute start-[-3px] top-[2px] z-50 h-4 w-4 md:h-4 md:w-4">
            <span className="absolute inline-flex h-full w-full animate-pulse rounded-full bg-green-500 drop-shadow" />
          </span>
          <Icon
            icon="mdi:whatsapp"
            className="h-9 w-9 text-black transition-all duration-300 hover:text-white md:h-11 md:w-11"
          />
        </button>
      </div>
    </div>
  );
};
